import { CheckboxVisibility, DetailsList, IColumn, Icon, SearchBox } from '@fluentui/react';
import * as React from 'react'
import { useTranslation } from 'react-i18next';
import { _renderRow } from '../../control/function/detailList';
import { NoDataFound } from '../../control/noDataFound';
import Paging from '../../control/paging';
import * as Api from '../../api/src'
import '../../css/components/test.scss'
import useToken from '../account/login/useToken';
import { commonfn, TestService } from '../../common/commonfn';
import { LeftMenuContext } from '../../context/leftMenu.context';

const TestsApi = new Api.TestsApi();
interface AssignedProductsProps {
    Item: Api.TestDto,
}
const AssignedProducts = ({ Item }: AssignedProductsProps) => {
    const { setSelectedMenuItem, } = React.useContext(LeftMenuContext);
    const { } = useToken();
    const { t } = useTranslation();

    const _columns = [
        {
            key: 'Stt', name: t("STT"), className: "flex-center", isResizable: true, maxWidth: 100, onRender: (item: Api.AssignedProductModel, index: number) => {
                return index + 1;
            }
        },
        {
            key: 'Name', name: t("ProductModel"), fieldName: 'Name', className: "flex-center", isResizable: true, minWidth: 300, onRender: (item: Api.AssignedProductModel) => {
                return item.Name;
            }
        },
        {
            key: 'Year', name: t("Matrix"), className: "flex-center", maxWidth: 300, minWidth: 200, onRender: (item: Api.AssignedProductModel) => {
                return item.Year;
            }
        }
    ] as IColumn[];
    
    const [FilterQuery, setFilterQuery] = React.useState<Api.AssignedProductRequestModel>({
        Page: 1, PageSize: 20, TestId: Item.Id
    });
  
    const [listMaster, setListMaster] = React.useState<Api.AssignedProductModelPaginatedResult | null>(null);
    const getList = async () => {
        let data = (await TestsApi.apiTestsIdAssignProductsPagedPost((Item.Id || 0).toString(), FilterQuery)).data;
        setListMaster(data);
    }
    React.useEffect(() => {
        setSelectedMenuItem("Tests");
    }, [])
    React.useEffect(() => {
        getList();
    }, [FilterQuery]);

    return (
        <div className="test-detail">
            <div className="page-content  margin-left-0 margin-right-0 ms-Grid" dir="ltr">
                <div className="ms-Grid  form-list" dir="ltr">
                    <div className="ms-Grid-row display-flex">
                        <div className="ms-Grid-col padding-left-0 margin-right-auto ms-md2" style={{ minWidth: 250 }}>
                            <SearchBox placeholder={t("Search")} onChange={(e, newValue) => { setFilterQuery({ ...FilterQuery, Search: newValue || '' }); }} />
                        </div>
                    </div>
                </div>
                <div className="ms-Grid-row">
                    {((listMaster?.Data?.length || 0) > 0) && (
                        <DetailsList
                            items={listMaster?.Data || []}
                            columns={_columns}
                            checkboxVisibility={CheckboxVisibility.hidden}
                        />)}
                    <NoDataFound isShow={listMaster?.Data?.length == 0}></NoDataFound>
                    <Paging TotalPage={listMaster?.TotalPages || 0} onChangePage={(page, pageSize) => { setFilterQuery({ ...FilterQuery, Page: page, PageSize: pageSize }); } } CurrentPage={FilterQuery.Page}  ></Paging>
                </div>
            </div>
        </div>
    );
}
export default AssignedProducts;